var React = require('react');

function CheckedInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M7.7 0.8C7.3 0.4 6.7 0.4 6.3 0.8L3 4.1L1.7 2.8C1.3 2.4 0.7 2.4 0.3 2.8C-0.1 3.2 -0.1 3.8 0.3 4.2L2.3 6.2C2.5 6.4 2.7 6.5 3 6.5C3.3 6.5 3.5 6.4 3.7 6.2L7.7 2.2C8.1 1.8 8.1 1.2 7.7 0.8Z"}));
}

CheckedInline.defaultProps = {"width":"8","height":"7","viewBox":"0 0 8 7","fill":"none"};

module.exports = CheckedInline;

CheckedInline.default = CheckedInline;
